module.exports = __webpack_public_path__ + "static/media/7.ab870051.jpg";